export const PRO_GATEWAY_ID: string = 'pro';
export const PLUS_GATEWAY_ID: string = 'gold';
export const ESSENTIAL_GATEWAY_ID: string = 'essentials';
export const FREE_GATEWAY_ID: string = 'free';

export const PLUS_SLUG: string = 'plus';
export const PRO_SLUG: string = 'pro';
export const ESSENTIALS_SLUG: string = 'essentials';
export const FREE_SLUG: string = 'free';
